function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import * as qiniu from 'qiniu-js';
import Cos from 'cos-js-sdk-v5';
import axios from 'axios';
import { ossUpload, getUploadKeysApi, attachSaveApi, localUpload } from '@/api/public';
import helper from '@/libs/helper';
import Tips from '@/utils/tips';
import { getFileExtension } from '@/libs/public';
var sign = function sign(method, publicKey, privateKey, md5, contentType, date, bucketName, fileName) {
  var CryptoJS = require('crypto-js'); // 这里使用了crypto-js加密算法库，安装方法会在后面说明
  var CanonicalizedResource = "/".concat(bucketName, "/").concat(fileName);
  var StringToSign = method + '\n' + md5 + '\n' + contentType + '\n' + date + '\n' + CanonicalizedResource; // 此处的md5以及date是可选的，contentType对于PUT请求是可选的，对于POST请求则是必须的
  var Signature = CryptoJS.HmacSHA1(StringToSign, privateKey);
  Signature = CryptoJS.enc.Base64.stringify(Signature);
  return 'UCloud' + ' ' + publicKey + ':' + Signature;
};
var optionItem = null;
export var uploader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, uploadType) {
    var fileSize,
      option,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fileSize = _args.length > 2 && _args[2] !== undefined ? _args[2] : helper.uploadSize;
          option = _args.length > 3 ? _args[3] : undefined;
          optionItem = option || {};
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var size = file.size;
            if (size > fileSize * 1024 * 1024) {
              Tips.msgError("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u5927\u4E8E".concat(fileSize, "MB"));
              return reject(false);
            }
            var type = getFileExtension(file.name).toLowerCase();

            // 默认
            if (parseInt(uploadType) === 0 && parseInt(helper.uploadTypes.indexOf(type)) === -1) {
              Tips.msgError("\u53EA\u80FD\u4E0A\u4F20".concat(helper.uploadTypes.join(','), "\u683C\u5F0F\u7684\u6587\u4EF6"));
              return reject(false);
            }
            // 只能上传图片格式

            if (parseInt(uploadType) === 1 && parseInt(helper.uploadTypes.indexOf(type)) === -1) {
              Tips.msgError("\u53EA\u80FD\u4E0A\u4F20".concat(helper.checkImageType.join(','), "\u683C\u5F0F\u7684\u6587\u4EF6"));
              return reject(false);
            }
            getUploadKeysApi().then(function (res) {
              baseUpload.videoUpload({
                type: res.data.type,
                evfile: file,
                res: res,
                uploading: function uploading(status, progress) {
                  // that.upload.videoIng = status
                  console.log('uploading');
                }
              }).then(function (re) {
                if (res.data.type === 'local') {
                  resolve(re.data);
                } else {
                  var fileData = {
                    name: file.name,
                    size: Math.round(file.size / 1024),
                    type: file.type,
                    url: re.url
                  };
                  attachSaveApi({
                    file: fileData,
                    way: option.way,
                    relation_type: option.relation_type,
                    relation_id: option.relation_id,
                    eid: option.eid
                  }).then(function (per) {
                    if (parseInt(per.status) === 200) {
                      Tips.msgSuccess('上传成功');
                    } else {
                      Tips.msgError('上传失败');
                    }
                    resolve(per.data);
                  }).catch(function (err) {
                    Tips.msgError('添加附件记录失败');
                    reject(err);
                  });
                }
              }).catch(function (err) {
                console.log('上传失败', err);
              });
            });
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function uploader(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var baseUpload = {
  videoUpload: function videoUpload(config) {
    var result;
    switch (config.type) {
      case 'COS':
        result = this.cosUpload(config.evfile, config.res.data, config.uploading);
        break;
      case 'OSS':
        result = this.ossHttp(config.evfile, config.res, config.uploading);
        break;
      case 'OBS':
        result = this.obsHttp(config.evfile, config.res, config.uploading);
        break;
      case 'US3':
        result = this.us3Http(config.evfile, config.res, config.uploading);
        break;
      case 'JDOSS':
        result = this.jdHttp(config.evfile, config.res, config.uploading);
        break;
      case 'CTOSS':
        result = this.obsHttp(config.evfile, config.res, config.uploading);
        break;
      case 'QINIU':
        result = this.qiniuHttp(config.evfile, config.res, config.uploading);
        break;
      case 'local':
        result = this.uploadMp4ToLocal(config.evfile, config.res, config.uploading);
        break;
    }
    return result;
  },
  cosUpload: function cosUpload(file, config, uploading) {
    var cos = new Cos({
      getAuthorization: function getAuthorization(options, callback) {
        callback({
          TmpSecretId: config.credentials.tmpSecretId,
          // 临时密钥的 tmpSecretId
          TmpSecretKey: config.credentials.tmpSecretKey,
          // 临时密钥的 tmpSecretKey
          XCosSecurityToken: config.credentials.sessionToken,
          // 临时密钥的 sessionToken
          ExpiredTime: config.expiredTime // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
        });
      }
    });
    var fileObject = file;
    var Key = fileObject.name;
    var pos = Key.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = Key.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    return new Promise(function (resolve, reject) {
      cos.sliceUploadFile({
        Bucket: config.bucket /* 必须 */,
        Region: config.region /* 必须 */,
        Key: filename /* 必须 */,
        Body: fileObject,
        // 上传文件对象
        onProgress: function onProgress(progressData) {
          uploading(progressData);
        }
      }, function (err, data) {
        if (err) {
          reject({
            msg: err
          });
        } else {
          resolve({
            url: 'http://' + data.Location,
            ETag: data.ETag
          });
        }
      });
    });
  },
  cosHttp: function cosHttp(evfile, res, videoIng) {
    // 腾讯云
    // 对更多字符编码的 url encode 格式
    var camSafeUrlEncode = function camSafeUrlEncode(str) {
      return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A');
    };
    var fileObject = evfile;
    var Key = fileObject.name;
    var pos = Key.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = Key.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    var data = res.data;
    var XCosSecurityToken = data.credentials.sessionToken;
    var url = data.url + camSafeUrlEncode(filename).replace(/%2F/g, '/');
    var xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);
    XCosSecurityToken && xhr.setRequestHeader('x-cos-security-token', XCosSecurityToken);
    xhr.upload.onprogress = function (e) {
      var progress = Math.round(e.loaded / e.total * 10000) / 100;
      videoIng(true, progress);
    };
    return new Promise(function (resolve, reject) {
      xhr.onload = function () {
        if (/^2\d\d$/.test('' + xhr.status)) {
          var ETag = xhr.getResponseHeader('etag');
          videoIng(false, 0);
          resolve({
            url: url,
            ETag: ETag
          });
        } else {
          reject({
            msg: '文件 ' + filename + ' 上传失败，状态码：' + xhr.statu
          });
        }
      };
      xhr.onerror = function () {
        reject({
          msg: '文件 ' + filename + '上传失败，请检查是否没配置 CORS 跨域规'
        });
      };
      xhr.send(fileObject);
      xhr.onreadystatechange = function () {};
    });
  },
  ossHttp: function ossHttp(evfile, res, videoIng) {
    var that = this;
    var fileObject = evfile;
    var file = fileObject.name;
    var pos = file.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = file.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    var formData = new FormData();
    var data = res.data;
    // 注意formData里append添加的键的大小写
    formData.append('key', filename); // 存储在oss的文件路径
    formData.append('OSSAccessKeyId', data.accessid); // accessKeyId
    formData.append('policy', data.policy); // policy
    formData.append('Signature', data.signature); // 签名
    // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
    formData.append('file', fileObject);
    formData.append('success_action_status', 200); // 成功后返回的操作码
    var url = data.host;
    var fileUrl = url + '/' + filename;
    videoIng(true, 100);
    return new Promise(function (resolve, reject) {
      axios.defaults.withCredentials = false;
      axios.post(url, formData).then(function () {
        // that.progress = 0;
        videoIng(false, 0);
        resolve({
          url: fileUrl
        });
      }).catch(function (res) {
        reject({
          msg: res
        });
      });
    });
  },
  obsHttp: function obsHttp(file, res, videoIng) {
    var fileObject = file;
    var Key = fileObject.name;
    var pos = Key.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = Key.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    var formData = new FormData();
    var data = res.data;
    // 注意formData里append添加的键的大小写
    formData.append('key', filename);
    formData.append('AccessKeyId', data.accessid);
    formData.append('policy', data.policy);
    formData.append('signature', data.signature);
    formData.append('file', fileObject);
    formData.append('success_action_status', 200);
    var url = data.host;
    var fileUrl = url + '/' + filename;
    videoIng(true, 100);
    return new Promise(function (resolve, reject) {
      axios.defaults.withCredentials = false;
      axios.post(url, formData).then(function () {
        videoIng(false, 0);
        resolve({
          url: data.cdn ? data.cdn + '/' + filename : fileUrl
        });
      }).catch(function (res) {
        reject({
          msg: res
        });
      });
    });
  },
  us3Http: function us3Http(file, res, videoIng) {
    var fileObject = file;
    var Key = fileObject.name;
    var pos = Key.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = Key.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    var data = res.data;
    var auth = sign('PUT', data.accessid, data.secretKey, '', fileObject.type, '', data.storageName, filename);
    return new Promise(function (resolve, reject) {
      axios.defaults.withCredentials = false;
      var url = "https://".concat(data.storageName, ".cn-bj.ufileos.com/").concat(filename);
      axios.put(url, fileObject, {
        headers: {
          Authorization: auth,
          'content-type': fileObject.type
        }
      }).then(function (res) {
        videoIng(false, 0);
        resolve({
          url: data.cdn ? data.cdn + '/' + filename : url
        });
      }).catch(function (res) {
        reject({
          msg: res
        });
      });
    });
  },
  qiniuHttp: function qiniuHttp(evfile, res, videoIng) {
    var uptoken = res.data.token;
    var file = evfile; // Blob 对象，上传的文件
    var Key = file.name; // 上传后文件资源名以设置的 key 为主，如果 key 为 null 或者 undefined，则文件资源名会以 hash 值作为资源名。
    var pos = Key.lastIndexOf('.');
    var suffix = '';
    if (pos !== -1) {
      suffix = Key.substring(pos);
    }
    var filename = new Date().getTime() + suffix;
    var fileUrl = res.data.domain + '/' + filename;
    var config = {
      useCdnDomain: true
    };
    var putExtra = {
      fname: '',
      // 文件原文件名
      params: {},
      // 用来放置自定义变量
      mimeType: null // 用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
    };
    var observable = qiniu.upload(file, filename, uptoken, putExtra, config);
    return new Promise(function (resolve, reject) {
      observable.subscribe({
        next: function next(result) {
          var progress = Math.round(result.total.loaded / result.total.size);
          videoIng(true, progress);
          // 主要用来展示进度
        },
        error: function error(errResult) {
          // 失败报错信息
          reject({
            msg: errResult
          });
        },
        complete: function complete(result) {
          // 接收成功后返回的信息
          videoIng(false, 0);
          resolve({
            url: res.data.cdn ? res.data.cdn + '/' + filename : fileUrl
          });
        }
      });
    });
  },
  // 京东云上传
  jdHttp: function jdHttp(evfile, r, videoIng) {
    var fileObject = evfile; // 获取的文件对象
    var formData = new FormData();
    formData.append('file', fileObject);
    return new Promise(function (resolve, reject) {
      ossUpload(r.data.upload_url, formData).then(function (res) {
        console.log(res);
      }).catch(function (err) {
        videoIng(true, 100);
        resolve(r.data);
      });
    });
  },
  // 本地上传
  uploadMp4ToLocal: function uploadMp4ToLocal(evfile, res, videoIng, option) {
    var fileObject = evfile; // 获取的文件对象
    var formData = new FormData();
    formData.append('file', fileObject);
    formData.append('way', optionItem.way);
    formData.append('relation_type', optionItem.relation_type);
    formData.append('relation_id', optionItem.relation_id);
    formData.append('eid', optionItem.eid);
    videoIng(true, 100);
    return localUpload(formData);
  }
};